import { createClient } from '@/prismicio';
import { Content, isFilled } from '@prismicio/client';
import { SliceComponentProps, SliceZone } from '@prismicio/react';

// Types
import { SliceContext } from '@/types/contexts/sliceZoneContext';

// Components
import { AdvertisementListener } from '@/slices/advertisements/Advertisement/AdvertisementListener';

// Slices
import { components as homeComponents } from '@/slices/home';
import { components as sharedComponents } from '@/slices/shared';

export type AdvertisementProps = SliceComponentProps<
  Content.AdvertisementSlice,
  SliceContext
>;

const Advertisement = async ({ slice, context }: AdvertisementProps) => {
  const { lang } = context;

  const { primary } = slice;
  const { advertisement_link } = primary;

  if (!isFilled.contentRelationship(advertisement_link)) {
    return null;
  }

  const { uid } = advertisement_link;

  if (!uid) {
    return null;
  }

  const client = await createClient();

  const { data } = await client.getByUID('advertisement', uid, { lang: lang });

  return (
    // Note : As part of initial feature creation `advertisement_type` will be null
    //        when we push the contract changes so this is to avoid the UI falling over
    //        at run time.
    <AdvertisementListener type={data.advertisement_type ?? 'Default'}>
      <SliceZone
        context={context}
        slices={data.slices}
        components={{ ...homeComponents, ...sharedComponents }}
      />
    </AdvertisementListener>
  );
};

export default Advertisement;
